import numeral from "numeral";
import moment from "moment";
import {
  registerLocale,
  setDefaultLocale,
} from "react-datepicker";
import de from "date-fns/locale/de";
import {
  roundPips,
} from "CommonCore/util";
import {
  isHoliday,
} from "feiertagejs";
export const ReactSelectTexts = {
  addLabelText: "\"{label}\" hinzufügen?",
  backspaceToRemoveMessage: "Rücktaste zum löschen von {label}",
  clearAllText: "Alles entfernen",
  clearValueText: "Eingabe entfernen",
  noResultsText: "Keine Daten vorhanden",
  placeholder: "Bitte wählen…",
};

export const LocaleDateFormat = "DD.MM.YYYY";
export const LocaleDateFormatShort = "DD.MM.YY";
export const LocaleDateFormatNumber = "DDMMYYYY";
export const LocaleDateFormatNumberShort = "DDMMYY";
export const LocaleMonthFormat = "MMMM YYYY";
export const LocaleTimeFormat = "DD.MM.YYYY HH:mm:ss";
export const IsoDateFormat = "YYYY-MM-DD";
export const LocaleNumberFormat = "0,0.[0000]";
export const LocaleSmallNumberFormat = "0.[0000]";
export const LowpNumberFormat = "0.[00]";
export const LocaleMoneyFormat = "0,0.00";
export const ShortMoneyFormat = "0,0.00";

export function formatNumber(number, format) {
  // 16.03.17 TH: Regel geändert (Zahlen < 1.000 sind small, statt Zahlen < 10.000 )
  return numeral(number).format(format || (number >= 1000 ? LocaleNumberFormat : LocaleSmallNumberFormat));
}

export function formatMoney(number, format) {
  return numeral(roundPips(number)).format(format || LocaleMoneyFormat) + "\u00A0€";
}

export function formatMoney2(number, format) {
  // Wie formatMoney, nur ohne Eurozeichen
  return numeral(roundPips(number)).format(format || LocaleMoneyFormat);
}

export function formatDate(value) {
  // 30.08.17 TH: + Zeitzonenhandling
  try {
    return value && (value.indexOf("+") !== -1 || value.endsWith("Z") ? moment : moment.utc)(value).format(LocaleDateFormat);
  } catch(err) {
    return moment.utc(value).format(LocaleDateFormat);
  }
}

export function isWorkDay(value) {
  /*
   * if (moment.utc(value).getDay()==0 || moment.utc(value).getDay()==7) {
   *  return false
   * }
   */

  const datum = new Date(value);
  const day1 = datum.getDay();
  // console.log(day1);
  if (day1 == 0 || day1 == 6) {
    return false;
  }
  if (isHoliday(datum, "BUND")) {
    return false;
  }
  if (isHoliday(datum, "NW")) {
    return false;
  }
  return true;
}

export function firstWorkDay(value) {
  let datum = new Date(value);
  const monat = datum.getMonth();
  const jahr = datum.getFullYear();
  let day = 0;
  do {
    day = day + 1;
    datum = new Date(jahr, monat, day);
    datum = moment(datum).format("YYYY-MM-DD");
    // console.log(datum)
  }
  while (isWorkDay(datum) == false);
  return datum;
}

export function isfirstWorkDay(value) {
  const datum1 = moment(new Date(value)).format("YYY-MM-DD");
  const datum2 = firstWorkDay(moment(datum1).format("YYYY-MM-DD"));

  /*
   * console.log(datum1);
   * console.log(datum2);
   */
  return datum1 == datum2;
}

export function formatDateTime(value) {
  // 16.10.17 TH: + Zeitzonenhandling
  try {
    return value && (value.indexOf("+") !== -1 || value.endsWith("Z") ? moment : moment.utc)(value).format(LocaleTimeFormat);
  } catch(err) {
    return moment.utc(value).format(LocaleTimeFormat);
  }
}

export function dateRange(ab, bis) {
  return (ab && (bis ? `${ formatDate(ab) } - ${ formatDate(bis) }` : `${ formatDate(ab) } - `)) || null;
}

moment.locale("de");

numeral.register("locale", "de", {
  delimiters: {
    thousands: ".",
    decimal: ",",
  },
  abbreviations: {
    thousand: "k",
    million: "m",
    billion: "b",
    trillion: "t",
  },
  currency: {
    symbol: "€",
  },
});
numeral.locale("de");

// react-datepicker locale settings
registerLocale("de", de);
setDefaultLocale("de");
